

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const WebhookProxy = () => {
  const location = useLocation();
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleWebhookRequest = async () => {
      try {
        // Extract query parameters
        const searchParams = new URLSearchParams(location.search);
        const tenant = searchParams.get('tenant');

        if (!tenant) {
          setError('No tenant parameter found');
          return;
        }

        // Forward the request to backend (generic webhook proxy)
        const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        const backendEndpoint = `${backendUrl}/webhook?${location.search}`;

        console.log(`Proxying webhook request to: ${backendEndpoint}`);

        // Make the request to backend
        const res = await fetch(backendEndpoint, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        // Handle the response
        if (res.ok) {
          const data = await res.text();
          setResponse(data);
          console.log('Webhook verification successful:', data);
        } else {
          setError(`Backend webhook request failed: ${res.status}`);
          console.error('Backend webhook request failed:', res.status);
        }
      } catch (err) {
        setError(`Error proxying webhook request: ${err.message}`);
        console.error('Error proxying webhook request:', err);
      }
    };

    handleWebhookRequest();
  }, [location]);

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h3>Webhook Error</h3>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  }

  if (response) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h3>Webhook Verification</h3>
        <p style={{ color: 'green' }}>Success: {response}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Processing webhook request...</p>
    </div>
  );
};

export default WebhookProxy;
